import React, { useState } from 'react';

import EffectContext from './effectContext';

const EffectProvider: React.FC<{}> = ({ children }) => {
	const [loader, setLoader] = useState(false);

	return <EffectContext.Provider value={{ loader, setLoader }}>{children}</EffectContext.Provider>;
};

export default EffectProvider;
